import { Sparkles } from 'lucide-react';
import { Inline } from '../../../../../design-system/inline/inline';
import { cn } from '../../../../../utils/cn';
import { exhaustiveCheck } from '../../../../../utils/exhaustive-check';

type ConfidenceScoreVariant = 'HIGH' | 'MEDIUM' | 'LOW';

type ConfidenceScoreBadgeProps = {
  confidenceScore?: number | null;
};

export const ConfidenceScoreBadge = ({ confidenceScore }: ConfidenceScoreBadgeProps) => {
  const variant = getConfidenceScoreVariant(confidenceScore);
  const badgeText = getBadgeText(variant);

  return (
    <Inline space={1.5} className="w-max rounded-full bg-white px-2 py-0.5">
      <div className="h-3 w-3">
        <Sparkles strokeWidth={1} color="#86868B" className="h-full w-full" />
      </div>

      <p
        className={cn('text-[10px] font-medium leading-5 tracking-tight', {
          'text-seapoint-green-badge': variant === 'HIGH',
          'text-seapoint-orange': variant === 'MEDIUM',
          'text-seapoint-red': variant === 'LOW',
        })}
      >
        {badgeText}
      </p>
    </Inline>
  );
};

const getConfidenceScoreVariant = (confidenceScore?: number | null): ConfidenceScoreVariant => {
  if (!confidenceScore || confidenceScore <= 70) {
    return 'LOW';
  }

  if (confidenceScore <= 90) {
    return 'MEDIUM';
  }

  return 'HIGH';
};

const getBadgeText = (variant: ConfidenceScoreVariant) => {
  switch (variant) {
    case 'HIGH':
      return 'High confidence';
    case 'MEDIUM':
      return 'Medium confidence';
    case 'LOW':
      return 'Low confidence';
    default:
      return exhaustiveCheck(variant);
  }
};
